<script setup lang="ts">
import { ArrowLeft } from 'lucide-vue-next'

defineEmits<{ leave: [] }>()

const { t } = useI18n()
</script>

<template>
  <div class="bg-app-bg absolute inset-0 z-50 flex flex-col items-center justify-center overflow-y-auto px-6 py-10">
    <div class="flex max-w-sm flex-col items-center text-center">
      <svg
        viewBox="8 6 144 90"
        fill="none"
        aria-hidden="true"
        class="w-48 [filter:drop-shadow(0_1px_2px_rgb(0_0_0/0.06))_drop-shadow(0_12px_24px_rgb(0_0_0/0.08))]"
      >
        <defs>
          <filter id="mobile-editor-notice-phone-shadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="-1" dy="3" stdDeviation="3" flood-opacity="0.1" />
          </filter>
        </defs>

        <rect x="30" y="10" width="96" height="64" rx="7" stroke-width="1" class="fill-background stroke-border" />
        <rect x="37" y="17" width="82" height="50" rx="3" class="fill-primary/5" />
        <rect x="43" y="23" width="16" height="38" rx="2" class="fill-border" />
        <rect x="64" y="23" width="30" height="4" rx="2" class="fill-border" />
        <rect x="64" y="31" width="22" height="4" rx="2" class="fill-border" />
        <rect x="64" y="43" width="49" height="18" rx="3" class="fill-primary" />
        <path
          d="m83 52 3.5 3.5L93 49"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="stroke-primary-foreground"
        />
        <path d="M12 74h128v4a6 6 0 0 1-6 6H18a6 6 0 0 1-6-6z" stroke-width="1" class="fill-background stroke-border" />
        <path d="M64 74h24v1a3 3 0 0 1-3 3H67a3 3 0 0 1-3-3z" class="fill-border" />

        <rect
          x="118"
          y="42"
          width="28"
          height="50"
          rx="6"
          stroke-width="1"
          filter="url(#mobile-editor-notice-phone-shadow)"
          class="fill-background stroke-border"
        />
        <path d="M128 47h8" stroke-width="2" stroke-linecap="round" class="stroke-surface-strong" />
        <circle cx="132" cy="67" r="8" class="fill-destructive/10" />
        <path d="m128.5 63.5 7 7m0-7-7 7" stroke-width="1.8" stroke-linecap="round" class="stroke-destructive" />
      </svg>

      <h1 class="mt-8 text-lg font-semibold">
        {{ t('pages.loyaltySupports.webapp.editor.structure.mobileNotice.title') }}
      </h1>
      <p class="text-foreground-secondary mt-2 text-sm">
        {{ t('pages.loyaltySupports.webapp.editor.structure.mobileNotice.description') }}
      </p>

      <Button variant="outline" class="mt-8" @click="$emit('leave')">
        <ArrowLeft />
        {{ t('pages.loyaltySupports.webapp.editor.structure.mobileNotice.leave') }}
      </Button>
    </div>
  </div>
</template>
